var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldbet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: #0a1b4e;\n      }\n\n      .cls-3 {\n        fill: #ffcb03;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.45,
    y: 18.45,
    width: 43.09,
    height: 43.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.45,
    y: 18.45,
    width: 43.09,
    height: 43.09
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 80,
    height: 80,
    rx: 10,
    ry: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m61.31,52.52c-.57,2.99-2.51,5.38-5.16,6.83-2.79,1.5-6.05,2.01-9.18,2.15-2.74.09-5.53.05-8.28.05,3.78-1.12,7.24-2.95,10.41-5.33v-20.03h-23.74l3.31,9.08h8.75v5.1c-2.08,1.31-4.59,1.73-7,1.73-1.99,0-3.97-.42-5.77-1.36-6.62-3.37-8.09-12.59-3.64-18.29,2.22-2.85,5.63-4.35,9.27-4.26,2.13.05,4.21.51,6.1,1.45,1.51.7,2.84,1.68,4.12,2.71l7.43-8.7c-1.18-.94-2.32-1.82-3.59-2.57-1.8-1.12-3.74-2.01-5.82-2.62h3.45c3.26,0,6.62-.09,9.74.98,1.89.65,3.64,1.73,4.97,3.23,1.51,1.78,2.27,4.02,2.27,6.32,0,2.99-1.14,5.8-3.55,7.72-1.28.98-2.79,1.68-4.21,2.43,2.98,1.08,6.1,2.15,8.32,4.63,2.03,2.29,2.32,5.85,1.8,8.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldbet);
export default __webpack_public_path__ + "static/media/goldbet.f75f6ad5e1a68f3d677b32c88cc78203.svg";
export { ForwardRef as ReactComponent };